import config from '@/config'

export default {
	id: 'SIMPLE_PREMIUM_4W_49_4W_49',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_49_4w_49_usd',
		},
		primer: 'prd_4ErBbKdA0XLB',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 4,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 28,
		priceMap: {
			USD: 49,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 49,
		},
	},
}
